<div [formGroup]="form" class="ovrrride-flange-input-wrap">
    <mat-label class="font-style" [ngbTooltip]="maxGasketStress" placement="right" container="body" tooltipClass="small-tooltip">
        <!-- Max Gasket Stress -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.MAX_GASKET_STRESS' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #maxGasketStress>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.MAX_GASKET_STRESS' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <div class="example-checkbox" [ngClass]="form.get('maxGasketStress').valid ? '' : 'highLight'">
        <div>
            <mat-checkbox class="example-margin checkbox-wrap" name="resultOptionEl" formControlName="isMaxGasketStress"></mat-checkbox>
        </div>
        <mat-form-field class="example-full-width" [floatLabel]="'never'">
            <input matInput formControlName="maxGasketStress" name="maxgasket_stress" [readonly]="!form.get('isMaxGasketStress').value" />
        </mat-form-field>
    </div>
</div>
